import React, { useState } from 'react';
import { Stream, StreamTab } from '../types';

interface StreamFormProps {
  onSubmit: (stream: { name: string; color: string; tab: StreamTab }) => void;
  onCancel: () => void;
  initialData?: Partial<Stream>;
  isEditing?: boolean;
}

const predefinedColors = [
  '#007bff', // Blue
  '#28a745', // Green
  '#ffc107', // Yellow
  '#dc3545', // Red
  '#6f42c1', // Purple
  '#fd7e14', // Orange
  '#20c997', // Teal
  '#e83e8c', // Pink
  '#6c757d', // Gray
  '#343a40', // Dark
];

const StreamForm: React.FC<StreamFormProps> = ({ 
  onSubmit, 
  onCancel, 
  initialData = {}, 
  isEditing = false 
}) => {
  const [name, setName] = useState(initialData.name || '');
  const [color, setColor] = useState(initialData.color || '#007bff');
  const [tab, setTab] = useState<StreamTab>(initialData.tab ?? null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit({
        name: name.trim(),
        color,
        tab
      });
      setName('');
      setColor('#007bff');
      setTab(null);
    }
  };

  return (
    <div className="stream-form-overlay">
      <div className="stream-form-modal">
        <h3>{isEditing ? 'Edit Stream' : 'Create New Stream'}</h3>
        
        <form onSubmit={handleSubmit} className="stream-form">
          <div className="form-group">
            <label htmlFor="stream-name">Stream Name</label>
            <input
              id="stream-name"
              type="text"
              placeholder="Enter stream name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              maxLength={50}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="stream-color">Stream Color</label>
            <div className="color-picker-section">
              <input
                id="stream-color"
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                className="color-input"
              />
              
              <div className="predefined-colors">
                {predefinedColors.map((presetColor) => (
                  <button
                    key={presetColor}
                    type="button"
                    className={`color-preset ${color === presetColor ? 'selected' : ''}`}
                    style={{ backgroundColor: presetColor }}
                    onClick={() => setColor(presetColor)}
                    title={presetColor}
                  />
                ))}
              </div>
            </div>
          </div>
          
          <div className="form-group">
            <label>Tab</label>
            <div className="tab-radio-group">
              <label className="tab-radio">
                <input
                  type="radio"
                  name="stream-tab"
                  checked={tab === 'work'}
                  onChange={() => setTab('work')}
                />
                Work
              </label>
              <label className="tab-radio">
                <input
                  type="radio"
                  name="stream-tab"
                  checked={tab === 'personal'}
                  onChange={() => setTab('personal')}
                />
                Personal
              </label>
              <label className="tab-radio">
                <input
                  type="radio"
                  name="stream-tab"
                  checked={tab === null}
                  onChange={() => setTab(null)}
                />
                Unassigned
              </label>
            </div>
          </div>

          <div className="form-buttons">
            <button type="submit" className="btn-primary">
              {isEditing ? 'Update Stream' : 'Create Stream'}
            </button>
            <button type="button" className="btn-secondary" onClick={onCancel}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StreamForm;